export default class listCategory {
    constructor() {
        const elements = document.querySelector(".js-list-category");

        if (elements) {
            import(/* webpackChunkName: "listCategory" */ "../classes/style/listCategory").then(res => {
                const listCategory = res.default;
                this.createInstance(listCategory, elements);
            });
        }
    }

    createInstance(listCategory, elements) {
        return new listCategory(elements);
    }
}
